export const numbersOnlyRegex = /^\d+$/;

// export const iranianMobileRegex = /^09[0-9]{9}$/;
export const iranianMobileRegex = /^[0-9]{11}$/;

export const MAXIMUM_THREE_DECIMAL_PATTERN = /^\d+(\.\d{1,3})?$/;
export const MAXIMUM_TWO_DECIMAL_PATTERN = /^\d+(\.\d{1,2})?$/;
export const DIGIT_NUMBER_PATTERN = /^\d+$/;
